import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListAutomakerComponent } from './list-automaker/list-automaker.component';
import { CreateAutomakerComponent } from './create-automaker/create-automaker.component';
import { UpdateAutomakerComponent } from './update-automaker/update-automaker.component';
import { ImportAutomakerOrdersComponent } from './import-automaker-orders/import-automaker-orders.component';
import { ListAutomakerPriceTableComponent } from './list-automaker-price-table/list-automaker-price-table.component';
import { UpdateAutomakerPriceTableComponent } from './update-automaker-price-table/update-automaker-price-table.component';
import { permissionGuard } from 'src/app/shared/guards/permission/permission.guard';
import { Permission } from 'src/app/shared/models/permission/permission-dto';

const routes: Routes = [
  {
    path: '',
    canActivate: [permissionGuard],
    data: { permission: Permission.LIST_AUTOMAKER },
    component: ListAutomakerComponent
  },
  {
    path: 'create',
    canActivate: [permissionGuard],
    data: { permission: Permission.CREATE_AUTOMAKER },
    component: CreateAutomakerComponent
  },
  {
    path: ':id/update',
    canActivate: [permissionGuard],
    data: { permission: Permission.UPDATE_AUTOMAKER },
    component: UpdateAutomakerComponent
  },
  {
    path: ':id/import-orders',
    canActivate: [permissionGuard],
    data: { permission: Permission.CREATE_AUTOMAKER_ORDER },
    component: ImportAutomakerOrdersComponent
  },
  {
    path: ':id/prices',
    canActivate: [permissionGuard],
    data: { permission: Permission.LIST_AUTOMAKER_PRICE },
    component: ListAutomakerPriceTableComponent
  },
  {
    path: ':id/update-price-table',
    canActivate: [permissionGuard],
    data: { permission: Permission.UPDATE_AUTOMAKER_PRICE },
    component: UpdateAutomakerPriceTableComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AutomakerRoutingModule {}
